// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pluralize } from "@guestsupply/XDL/Utilities";
import { CartsDataViewContext } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";

export interface SavedOrdersResultCountStyles {
    SavedOrderCountText?: TypographyPresentationProps;
}

export const resultCountStyles: SavedOrdersResultCountStyles = {};

const styles = resultCountStyles;

const SavedOrdersCount: FC<WidgetProps> = () => {
    const SavedOrdersDataView = useContext(CartsDataViewContext);

    if (!SavedOrdersDataView.value || !SavedOrdersDataView.pagination) {
        return null;
    }

    const { totalItemCount } = SavedOrdersDataView.pagination;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.SavedOrderCountText} data-test-selector="SavedOrders_TotalCount">
            {pluralize(totalItemCount, translate("order"), { showNumber: true })}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: SavedOrdersCount,
    definition: {
        group: "Saved Order List",
        displayName: "Saved Orders Total Count",
        allowedContexts: ["SavedOrderListPage"],
    },
};

export default widgetModule;
